import { render, staticRenderFns } from "./monitior.vue?vue&type=template&id=5354d506&scoped=true"
import script from "./monitior.vue?vue&type=script&lang=js"
export * from "./monitior.vue?vue&type=script&lang=js"
import style0 from "./monitior.vue?vue&type=style&index=0&id=5354d506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354d506",
  null
  
)

export default component.exports